<hr> 

<footer class ="page-footer font-smallpt-4">

    <!--Rodapé-->
    <div class="container">

            <div class="row">
                <!--TituloRepassa-->
                <div class="col-md-4 justify-content-center">
                    <h5 class="colorFont"> Repassa </h5> 
                    <p class="text text-justify">Somos uma rede social criada com o propósito de dar novos significados a itens seminovos, como móveis, eletrodomésticos e roupas. Nosso objetivo é conectar pessoas que estão buscando por doações à pessoas procurando se desapegar de itens que não utilizam mais.</p>               
                </div>
                <!--/TituloRepassa-->

                <!--TituloRedesSociais-->
                <div class="col-md-2 justify-content-center">
                    <h5 class="colorFont">DoAre</h5>
                    <p>
                        <a class="colorFont selecao " href="#equipe">Equipe</a>
                    </p>

                    <p>
                        <a class=" colorFont selecao " href="#">Contato</a>
                    </p>
                    <div class="d-flex justify-content-start">
   
                        <ul class="social-network mt-3">
                            <li>
                                <a href="https://www.facebook.com/" target="_blank" class="iconFace">
                                    <i class="fa fa-facebook" aria-hidden="true"></i>
                                </a>
                            </li>
                
                            <li>
                                <a href="https://www.instagram.com/" target="_blank" class="iconInsta">
                                    <i class="fa fa-instagram" aria-hidden="true"></i>
                                </a>
                            </li>
                
                            <li>
                                <a href="https://www.github.com/" target="_blank" class="iconLin">
                                    <i class="fa fa-github" aria-hidden="true"></i>
                                </a>
                            </li>
                
                
                        </ul>
             
                        
                
                      </div>

                </div>
                <!--TituloRedesSociais-->

                <!--TituloNoticias-->
                <div class="col-md-6">
                    <h5 class="colorFont">Notícias</h5>
                    <p class="mt-2 text">Fique por dentro de nossa atualizações</p>
                    <div class="form-group">
                        <input class="form-control mt-2" type="text" name="email" placeholder="Digite seu e-mail"> 
                        <div class="pt-3 button">
                            <button class="btn btn-sm btn-outline-warning" type="submit">Enviar <i class="fa fa-paper-plane-o" aria-hidden="true"></i> </button>
                        </div>
                </div>
                <!--/TituloNoticias-->
                
                </div>
  
         </div>
        
    </div>
    
     <!--Copyright-->
     <div class="footer-copyright bg-warning text-center py-3">
        <span class="text-light"> © 2021 Copyright </span>
    
    </div>

</footer>       